import { render, staticRenderFns } from "./plantao.vue?vue&type=template&id=62046617"
import script from "./plantao.vue?vue&type=script&lang=js"
export * from "./plantao.vue?vue&type=script&lang=js"
import style0 from "./plantao.vue?vue&type=style&index=0&id=62046617&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports